import {useSearchParams} from 'react-router-dom';
import {useSelector} from 'react-redux';

import {httpMonitorAPI} from 'features/http/api/httpMonitorAPI';
import {formatDateRange, setupDefaultDateFilter} from 'features/http/lib/dateFilterHelper';
import IHttpMonitorResult from 'features/http/model/HttpMonitor/IHttpMonitorResult';
import IPagination from 'shared/api/model/IPagination';
import {userSelector} from 'entities/user';
import {getPage, objectToArray} from 'shared/lib/filterHelper';

export interface IUseHttpMonitorLogs {
    pagination: IPagination<IHttpMonitorResult> | undefined,
    isLoading: boolean,
    isFetching: boolean,
    refetch: () => void,
    dateRange: string,
    tzString: string | null | undefined,
}

export const useHttpMonitorLogs = (monitorUuid: string, usePageFromUrl: boolean): IUseHttpMonitorLogs => {
    const user = useSelector(userSelector);
    const [searchParams] = useSearchParams();
    const page = usePageFromUrl ? getPage(searchParams) : 1;
    const filters = setupDefaultDateFilter(searchParams);

    const {data: pagination, isLoading, isFetching, refetch} = httpMonitorAPI.useGetHttpMonitorResultsQuery({
        uuid: monitorUuid,
        page,
        filters: objectToArray(filters),
    });

    return {
        pagination,
        isLoading,
        isFetching,
        refetch,
        dateRange: formatDateRange(filters),
        tzString: user?.timezone,
    };
};

export default useHttpMonitorLogs;
